import React from 'react'
import Header from '../Header/Header'
import EngagementsComp from './EngagementsComp'
import Footer from '../Footer/Footer'

function Engagements() {
  return (
   <>
   <Header/>
   <EngagementsComp/>
   <Footer/>
   </>
  )
}

export default Engagements